import { ApplicationDocumentsDataModel } from '@/shared/models/customers.model';
import { DocsDataUIModel } from '@/shared/types/shared-types/documents.type';
import {
  ApplicationDocsUIModel,
  ApplicationDocumentsDataUIModel
} from '@/shared/ui-models/customers.ui-model';

function mapToModel(docs: ApplicationDocumentsDataUIModel): ApplicationDocumentsDataModel {
  const applicationDocs = {
    recommendationLetter: 'recommendationLetter',
    carLicenseFront: 'carLicenseFront',
    carLicenseBack: 'carLicenseBack',
    oldCarLicenseFront: 'oldCarLicenseFront',
    oldCarLicenseBack: 'oldCarLicenseBack',
    downpaymentReceipt: 'downpaymentReceipt',
    insurancePolicy: 'insurancePolicy',
    stampedApplicationForm: 'stampedApplicationForm',
    carInspectionImages: 'carInspectionImages',
    violationCerificateReciept: 'violationCerificateReciept',
    registeredContract: 'registeredContract',
    adminFeesPaymentReceipt: 'adminFeesPaymentReceipt',
    purchaseOrder: 'purchaseOrder'
  };

  const mapArrayProperty = (property: keyof ApplicationDocsUIModel) => {
    return docs[property]?.map((file) => file.file) ?? [];
  };

  const result: ApplicationDocumentsDataModel = {
    applicationId: docs.applicationId ?? ''
  };

  for (const [dataProperty, uiProperty] of Object.entries(applicationDocs) as [
    keyof ApplicationDocsUIModel,
    keyof ApplicationDocsUIModel
  ][]) {
    if (docs[dataProperty]?.length) {
      result[uiProperty] = mapArrayProperty(dataProperty);
    }
  }

  return result;
}

function mapToUI(docs: ApplicationDocumentsDataModel): ApplicationDocumentsDataUIModel {
  const result: ApplicationDocsUIModel = {};
  Object.keys(docs).forEach((key) => {
    const docArray = docs[key as keyof ApplicationDocsUIModel];
    if (docArray && docArray.length) {
      result[key as keyof ApplicationDocsUIModel] = docArray.map((doc) => ({
        dataURL: doc.url,
        file: { name: doc.key?.split('/')[1] },
        id: doc.id,
        key: doc.key,
        createdAt: doc.createdAt,
        createdByUser: doc.createdByUser
      })) as unknown as DocsDataUIModel[];
    }
  });
  return result;
}

const applicationDocsMapper = { mapToModel, mapToUI };
export default applicationDocsMapper;
